module.exports = __webpack_public_path__ + "static/media/error.ba99b32a.svg";